export const UNAUTHENTICATED_ROUTES = [
  /^\/sign-in$/,
  /^\/sign-up$/,
  /^\/projects\/export\/[^/]+$/,
];

export const REDIRECT_AUTH_ROUTES = [/^\/sign-in$/, /^\/sign-up$/];

export function matchPath(currentPath: string, paths: RegExp[]): boolean {
  return paths.some((path) => {
    return path.test(currentPath);
  });
}
